import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useEffect, useState } from 'react';
import ResourceAPI from '../services/resource.api.service';
import useAlert from './Alert/useAlert';

export const CountrySelector = ({label, onChange}) => {
    const {showErrorAlert} = useAlert();
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        ResourceAPI
            .getCountry()
            .then(result => setCountries(result.items))
            .catch(err => showErrorAlert(err.response.data.message));
    }, []);

    return (
        <Autocomplete
            sx={{mb: 1, mt: 1}}
            options={countries}
            fullWidth
            variant="outlined"
            size="small"
            onChange={(event, country) => onChange(country)}
            getOptionLabel={country => country?.name}
            renderInput={params => <TextField {...params} variant="standard" label={label} required/>}
        />
    );
};
